import Progress from 'redux-progress';

import {
  ARCHIVE_UNARCHIVE_LICENSE,
  CLEAR_DEVELOPER_LICENSE,
  DEVELOPER_LICENSE,
  LICENSE_DETAILS,
  RESET_ARCHIVE_UNARCHIVE_LICENSE,
} from '../actions/license';
import { MACLicenseAction, MACLicenseState } from '../models';

export const initialState = {
  isArchivedLicense: Progress.none,
  developerLicense: Progress.none,
  licenseDetails: Progress.none,
};

export default (
  state: MACLicenseState = initialState,
  action: MACLicenseAction,
): MACLicenseState => {
  switch (action.type) {
    case ARCHIVE_UNARCHIVE_LICENSE:
      return {
        ...state,
        isArchivedLicense: action.progress,
      };
    case RESET_ARCHIVE_UNARCHIVE_LICENSE:
      return {
        ...state,
        isArchivedLicense: null,
      };
    case DEVELOPER_LICENSE:
      return {
        ...state,
        developerLicense: {
          ...state.developerLicense,
          [action.id]: action.progress,
        },
      };
    case CLEAR_DEVELOPER_LICENSE:
      return {
        ...state,
        developerLicense: null,
      };
    case LICENSE_DETAILS:
      return {
        ...state,
        licenseDetails: {
          ...state.licenseDetails,
          [action.id]: action.progress,
        },
      };
    default:
      return state;
  }
};
